module.exports = {
	"1340501": {
		"cnae_description": "ESTAMPARIA E TEXTURIZACAO EM FIOS, TECIDOS, ARTEFATOS TEXTEIS E PECAS DO VESTUARIO",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"1340502": {
		"cnae_description": "Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário",
		"service_code": "14.10",
		"service_description": "Tinturaria e lavanderia."
	},
	"1340599": {
		"cnae_description": "Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário",
		"service_code": "14.10",
		"service_description": "Tinturaria e lavanderia."
	},
	"1411802": {
		"cnae_description": "Facção de roupas íntimas",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1412602": {
		"cnae_description": "Confecção, sob medida, de peças do vestuário, exceto roupas íntimas",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1412603": {
		"cnae_description": "Facção de peças do vestuário, exceto roupas íntimas",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1413401": {
		"cnae_description": "CONFECCAO DE ROUPAS PROFISSIONAIS, EXCETO SOB MEDIDA",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1413402": {
		"cnae_description": "Confecção, sob medida, de roupas profissionais",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1413403": {
		"cnae_description": "Facção de roupas profissionais",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1531902": {
		"cnae_description": "Acabamento de calçados de couro sob contrato",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"1622699": {
		"cnae_description": "Fabricação de outros artigos de carpintaria para construção",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"1629301": {
		"cnae_description": "Fabricação de artefatos diversos de madeira, exceto móveis",
		"service_code": "14.07",
		"service_description": "Colocação de molduras e congêneres."
	},
	"1741901": {
		"cnae_description": "Fabricação de formulários contínuos",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1811301": {
		"cnae_description": "Impressão de jornais",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1811302": {
		"cnae_description": "Impressão de livros, revistas e outras publicações periódicas",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1812100": {
		"cnae_description": "Impressão de material de segurança",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1813001": {
		"cnae_description": "Impressão de material para uso publicitário",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1813099": {
		"cnae_description": "Impressão de material para outros usos",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1821100": {
		"cnae_description": "Serviços de pré-impressão",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1822901": {
		"cnae_description": "Serviços de encadernação e plastificação",
		"service_code": "13.05",
		"service_description": "Composição gráfica, fotocomposição, clicheria, zincografia, litografia, fotolitografia."
	},
	"1822999": {
		"cnae_description": "Serviços de acabamentos gráficos, exceto encadernação e plastificação",
		"service_code": "14.08",
		"service_description": "Encadernação, gravação e douração de livros, revistas e congêneres."
	},
	"1830001": {
		"cnae_description": "REPRODUCAO DE SOM EM QUALQUER SUPORTE",
		"service_code": "13.02",
		"service_description": "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres."
	},
	"1830002": {
		"cnae_description": "REPRODUCAO DE VIDEO EM QUALQUER SUPORTE",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"1830003": {
		"cnae_description": "REPRODUCAO DE SOFTWARE EM QUALQUER SUPORTE",
		"service_code": "01.03",
		"service_description": "Processamento de dados e congêneres."
	},
	"2212900": {
		"cnae_description": "Reforma de pneumáticos usados",
		"service_code": "14.04",
		"service_description": "Recauchutagem ou regeneração de pneus."
	},
	"2330305": {
		"cnae_description": "PREPARAÇÃO DE MASSA DE CONCRETO E AGAMASSA PARA CONSTRUÇÃO",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"2391501": {
		"cnae_description": "BRITAMENTO DE PEDRAS, EXCETO ASSOCIADO À EXTRAÇÃO",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2391502": {
		"cnae_description": "APARELHAMENTO DE PEDRAS PARA CONSTRUÇÃO, EXCETO ASSOCIADO À EXTRAÇÃO",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2391503": {
		"cnae_description": "APARELHMANTO DE PLACAS E EXECUÇÃO DE TRABALHOS EM MÁRMORE, GRANITO, ARDÓSIA E OUTRAS PEDRAS",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2399101": {
		"cnae_description": "Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"2512800": {
		"cnae_description": "Fabricação de esquadrias de metal",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"2539001": {
		"cnae_description": "Serviços de usinagem, tornearia e solda",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2539002": {
		"cnae_description": "Serviços de tratamento e revestimento em metais",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2542000": {
		"cnae_description": "Fabricação de artigos de serralheria, exceto esquadrias",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"2599301": {
		"cnae_description": "Serviços de confecção de armações metálicas para a construção",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"2599302": {
		"cnae_description": "Serviços de corte e dobra de metais",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2722802": {
		"cnae_description": "Recondicionamento de baterias e acumuladores para veículos automotores",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"2930103": {
		"cnae_description": "FABRICAÇÃO DE CABINES, CARROCERIAS E REBOQUES PARA OUTROS VEÍCULOS AUTOMOTORES, EXCETO CAMINHÕES E ÔNIBUS",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"2950600": {
		"cnae_description": "Recondicionamento e recuperação de motores para veículos automotores",
		"service_code": "14.03",
		"service_description": "Recondicionamento de motores (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3211601": {
		"cnae_description": "Lapidação de gemas",
		"service_code": "39.01",
		"service_description": "Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)."
	},
	"3250703": {
		"cnae_description": "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda",
		"service_code": "04.14",
		"service_description": "Próteses sob encomenda."
	},
	"3250706": {
		"cnae_description": "Serviços de prótese dentária",
		"service_code": "04.14",
		"service_description": "Próteses sob encomenda."
	},
	"3250709": {
		"cnae_description": "Serviços de laboratórios ópticos",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"3299003": {
		"cnae_description": "Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos",
		"service_code": "24.01",
		"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres."
	},
	"3299004": {
		"cnae_description": "Fabricação de painéis e letreiros luminosos",
		"service_code": "24.01",
		"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres."
	},
	"3311200": {
		"cnae_description": "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3312102": {
		"cnae_description": "Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3312103": {
		"cnae_description": "Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3312104": {
		"cnae_description": "Manutenção e reparação de equipamentos e instrumentos ópticos",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3313901": {
		"cnae_description": "Manutenção e reparação de geradores, transformadores e motores elétricos",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3313902": {
		"cnae_description": "Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3313999": {
		"cnae_description": "Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314701": {
		"cnae_description": "Manutenção e reparação de máquinas motrizes não-elétricas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314702": {
		"cnae_description": "Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314703": {
		"cnae_description": "Manutenção e reparação de válvulas industriais",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314704": {
		"cnae_description": "Manutenção e reparação de compressores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314705": {
		"cnae_description": "Manutenção e reparação de equipamentos de transmissão para fins industriais",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314706": {
		"cnae_description": "Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314707": {
		"cnae_description": "Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314708": {
		"cnae_description": "Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314709": {
		"cnae_description": "Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não eletrônicos para escritório",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314710": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314711": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314712": {
		"cnae_description": "Manutenção e reparação de tratores agrícolas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314713": {
		"cnae_description": "Manutenção e reparação de máquinas- ferramenta",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314714": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314715": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314716": {
		"cnae_description": "Manutenção e reparação de tratores, exceto agrícolas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314717": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314718": {
		"cnae_description": "Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas- ferramenta",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314719": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314720": {
		"cnae_description": "Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314721": {
		"cnae_description": "Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314722": {
		"cnae_description": "Manutenção e reparação de máquinas e aparelhos para a indústria do plástico",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3314799": {
		"cnae_description": "Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3315500": {
		"cnae_description": "Manutenção e reparação de veículos ferroviários",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3316301": {
		"cnae_description": "Manutenção e reparação de aeronaves, exceto a manutenção na pista",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3316302": {
		"cnae_description": "Manutenção de aeronaves na pista",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3317101": {
		"cnae_description": "Manutenção e reparação de embarcações e estruturas flutuantes",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3317102": {
		"cnae_description": "Manutenção e reparação de embarcações para esporte e lazer",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3319800": {
		"cnae_description": "Manutenção e reparação de equipamentos e produtos não especificados anteriormente",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"3321000": {
		"cnae_description": "Instalação de máquinas e equipamentos industriais",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"3329501": {
		"cnae_description": "Serviços de montagem de móveis de qualquer material",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"3329599": {
		"cnae_description": "Instalação de outros equipamentos não especificados anteriormente",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"3514000": {
		"cnae_description": "Distribuição de energia elétrica",
		"service_code": "03.04",
		"service_description": "Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza."
	},
	"3520402": {
		"cnae_description": "Distribuição de combustíveis gasosos por redes urbanas",
		"service_code": "03.04",
		"service_description": "Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza."
	},
	"3702900": {
		"cnae_description": "Atividades relacionadas a esgoto, exceto a gestão de redes",
		"service_code": "07.10",
		"service_description": "Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres."
	},
	"3811400": {
		"cnae_description": "Coleta de resíduos não-perigosos",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3812200": {
		"cnae_description": "Coleta de resíduos perigosos",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3821100": {
		"cnae_description": "Tratamento e disposição de resíduos não- perigosos",
		"service_code": "07.12",
		"service_description": "Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biolõgicos"
	},
	"3822000": {
		"cnae_description": "Tratamento e disposição de resíduos perigosos",
		"service_code": "07.12",
		"service_description": "Controle e tratamento de efluentes de qualquer natureza e de agentes físicos, químicos e biolõgicos"
	},
	"3831901": {
		"cnae_description": "Recuperação de sucatas de alumínio",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3831999": {
		"cnae_description": "Recuperação de materiais metálicos, exceto alumínio",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3832700": {
		"cnae_description": "Recuperação de materiais plásticos",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3839401": {
		"cnae_description": "Usinas de compostagem",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3839499": {
		"cnae_description": "Recuperação de materiais não especificados anteriormente",
		"service_code": "07.09",
		"service_description": "Varrição, coleta, remoção, incineração, tratamento, reciclagem, separação e destinação final de lixo, rejeitos e outros resíduos quaisquer."
	},
	"3900500": {
		"cnae_description": "Descontaminação e outros serviços de gestão de resíduos",
		"service_code": "07.18",
		"service_description": "Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres."
	},
	"4120400": {
		"cnae_description": "Construção de edifícios",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4211101": {
		"cnae_description": "Construção de rodovias e ferrovias",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4211102": {
		"cnae_description": "Pintura para sinalização em pistas rodoviárias e aeroportos",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4212000": {
		"cnae_description": "Construção de obras-de-arte especiais",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4213800": {
		"cnae_description": "Obras de urbanização – ruas, praças e calçadas",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4221901": {
		"cnae_description": "Construção de barragens e represas para geração de energia elétrica",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4221902": {
		"cnae_description": "Construção de estações e redes de distribuição de energia elétrica",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4221903": {
		"cnae_description": "Manutenção de redes de distribuição de energia elétrica",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4221904": {
		"cnae_description": "Construção de estações e redes de telecomunicações",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4221905": {
		"cnae_description": "Manutenção de estações e redes de telecomunicações",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4222701": {
		"cnae_description": "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4222702": {
		"cnae_description": "Obras de irrigação",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4223500": {
		"cnae_description": "Construção de redes de transportes por dutos, exceto para água e esgoto",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4291000": {
		"cnae_description": "Obras portuárias, marítimas e fluviais",
		"service_code": "07.18",
		"service_description": "Limpeza e dragagem de rios, portos, canais, baías, lagos, lagoas, represas, açudes e congêneres."
	},
	"4292801": {
		"cnae_description": "Montagem de estruturas metálicas",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4292802": {
		"cnae_description": "Obras de montagem industrial",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4299501": {
		"cnae_description": "Construção de instalações esportivas e recreativas",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4299599": {
		"cnae_description": "Outras obras de engenharia civil não especificadas anteriormente",
		"service_code": "07.17",
		"service_description": "Escoramento, contenção de encostas e serviços congêneres."
	},
	"4311801": {
		"cnae_description": "Demolição de edifícios e outras estruturas",
		"service_code": "07.04",
		"service_description": "Demolição."
	},
	"4311802": {
		"cnae_description": "Preparação de canteiro e limpeza de terreno",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4312600": {
		"cnae_description": "Perfurações e sondagens",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4313400": {
		"cnae_description": "Obras de terraplenagem",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4319300": {
		"cnae_description": "Serviços de preparação do terreno não especificados anteriormente",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4321500": {
		"cnae_description": "Instalação e manutenção elétrica",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4322301": {
		"cnae_description": "Instalações hidráulicas, sanitárias e de gás",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4322302": {
		"cnae_description": "Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4322303": {
		"cnae_description": "Instalações de sistema de prevenção contra incêndio",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"4329101": {
		"cnae_description": "Instalação de painéis publicitários",
		"service_code": "24.01",
		"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres."
	},
	"4329102": {
		"cnae_description": "Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"4329103": {
		"cnae_description": "Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes, exceto de fabricação própria",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4329104": {
		"cnae_description": "Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"4329105": {
		"cnae_description": "Tratamentos térmicos, acústicos ou de vibração",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4329199": {
		"cnae_description": "Outras obras de instalações em construções não especificadas anteriormente",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4330401": {
		"cnae_description": "Impermeabilização em obras de engenharia civil",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4330402": {
		"cnae_description": "Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material",
		"service_code": "14.13",
		"service_description": "Carpintaria e serralheria."
	},
	"4330403": {
		"cnae_description": "Obras de acabamento em gesso e estuque",
		"service_code": "14.07",
		"service_description": "Colocação de molduras e congêneres."
	},
	"4330404": {
		"cnae_description": "Serviços de pintura de edifícios em geral",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4330405": {
		"cnae_description": "Aplicação de revestimentos e de resinas em interiores e exteriores",
		"service_code": "07.08",
		"service_description": "Calafetação."
	},
	"4330499": {
		"cnae_description": "Outras obras de acabamento da construção",
		"service_code": "07.06",
		"service_description": "Colocação e instalação de tapetes, carpetes, assoalhos, cortinas, revestimentos de parede, vidros, divisórias, placas de gesso e congêneres, com material fornecido pelo tomador do serviço."
	},
	"4391600": {
		"cnae_description": "Obras de fundações",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4399101": {
		"cnae_description": "Administração de obras",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4399102": {
		"cnae_description": "Montagem e desmontagem de andaimes e outras estruturas temporárias",
		"service_code": "03.05",
		"service_description": "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário."
	},
	"4399103": {
		"cnae_description": "Obras de alvenaria",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4399104": {
		"cnae_description": "Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras",
		"service_code": "03.05",
		"service_description": "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário."
	},
	"4399105": {
		"cnae_description": "Perfuração e construção de poços de água",
		"service_code": "07.02",
		"service_description": "Execução, por administração, empreitada ou subempreitada, de obras de construção civil, hidráulica ou elétrica e de outras obras semelhantes, inclusive sondagem, perfuração de poços, escavação, drenagem e irrigação, terraplenagem, pavimentação, concretagem e a instalação e montagem de produtos, peças e equipamentos (exceto o fornecimento de mercadorias produzidas pelo prestador de serviços fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4399199": {
		"cnae_description": "Serviços especializados para construção não especificados anteriormente",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"4512901": {
		"cnae_description": "Representantes comerciais e agentes do comércio de veículos automotores",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4512902": {
		"cnae_description": "Comércio sob consignação de veículos automotores",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4520001": {
		"cnae_description": "Serviços de manutenção e reparação mecânica de veículos automotores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4520002": {
		"cnae_description": "Serviços de lanternagem ou funilaria e pintura de veículos automotores",
		"service_code": "14.12",
		"service_description": "Funilaria e lanternagem."
	},
	"4520003": {
		"cnae_description": "Serviços de manutenção e reparação elétrica de veículos automotores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4520004": {
		"cnae_description": "Serviços de alinhamento e balanceamento de veículos automotores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4520005": {
		"cnae_description": "Serviços de lavagem, lubrificação e polimento de veículos automotores",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"4520006": {
		"cnae_description": "Serviços de borracharia para veículos automotores",
		"service_code": "14.04",
		"service_description": "Recauchutagem ou regeneração de pneus."
	},
	"4520007": {
		"cnae_description": "Serviços de instalação, manutenção e reparação de acessórios para veículos automotores",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4520008": {
		"cnae_description": "Serviços de capotaria",
		"service_code": "14.11",
		"service_description": "Tapeçaria e reforma de estofamentos em geral."
	},
	"4530706": {
		"cnae_description": "Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4542101": {
		"cnae_description": "Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4543900": {
		"cnae_description": "Manutenção e reparação de motocicletas e motonetas",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4611700": {
		"cnae_description": "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4612500": {
		"cnae_description": "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4613300": {
		"cnae_description": "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4614100": {
		"cnae_description": "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4615000": {
		"cnae_description": "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4616800": {
		"cnae_description": "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4617600": {
		"cnae_description": "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4618401": {
		"cnae_description": "Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4618402": {
		"cnae_description": "Representantes comerciais e agentes do comércio de instrumentos e materiais odonto- médico-hospitalares",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4618403": {
		"cnae_description": "Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4618499": {
		"cnae_description": "Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4619200": {
		"cnae_description": "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"4751202": {
		"cnae_description": "Recarga de cartuchos para equipamentos de informática",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"4771702": {
		"cnae_description": "Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas",
		"service_code": "04.07",
		"service_description": "Serviços farmacêuticos"
	},
	"4771703": {
		"cnae_description": "Comércio varejista de produtos farmacêuticos homeopáticos",
		"service_code": "04.07",
		"service_description": "Serviços farmacêuticos"
	},
	"4911600": {
		"cnae_description": "Transporte ferroviário de carga",
		"service_code": "03.04",
		"service_description": "Locação, sublocação, arrendamento, direito de passagem ou permissão de uso, compartilhado ou não, de ferrovia, rodovia, postes, cabos, dutos e condutos de qualquer natureza."
	},
	"4912402": {
		"cnae_description": "Transporte ferroviário de passageiros municipal e em região metropolitana",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4912403": {
		"cnae_description": "Transporte metroviário",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4921301": {
		"cnae_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4923001": {
		"cnae_description": "Serviço de táxi",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4923002": {
		"cnae_description": "Serviço de transporte de passageiros – locação de automóveis com motorista",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4924800": {
		"cnae_description": "Transporte escolar",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4929901": {
		"cnae_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4929903": {
		"cnae_description": "Organização de excursões em veículos rodoviários próprios, municipal",
		"service_code": "09.02",
		"service_description": "Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
	},
	"4929904": {
		"cnae_description": "Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional",
		"service_code": "09.02",
		"service_description": "Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
	},
	"4930201": {
		"cnae_description": "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4930203": {
		"cnae_description": "Transporte rodoviário de produtos perigosos",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4930204": {
		"cnae_description": "Transporte rodoviário de mudanças",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4940000": {
		"cnae_description": "TRANSPORTE DUTOVIÁRIO",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"4950700": {
		"cnae_description": "Trens turísticos, teleféricos e similares",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5021101": {
		"cnae_description": "Transporte por navegação interior de carga, municipal, exceto travessia",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5022001": {
		"cnae_description": "Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5030101": {
		"cnae_description": "Navegação de apoio marítimo",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5030102": {
		"cnae_description": "Navegação de apoio portuário",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5091201": {
		"cnae_description": "Transporte por navegação de travessia, municipal",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5099801": {
		"cnae_description": "Transporte aquaviário para passeios turísticos",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5112999": {
		"cnae_description": "Outros serviços de transporte aéreo de passageiros não-regular",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5211701": {
		"cnae_description": "Armazéns gerais – emissão de warrant",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5211702": {
		"cnae_description": "Guarda-móveis",
		"service_code": "11.04",
		"service_description": "Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie"
	},
	"5211799": {
		"cnae_description": "Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5212500": {
		"cnae_description": "Carga e descarga",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5221400": {
		"cnae_description": "Concessionárias de rodovias, pontes, túneis e serviços relacionados",
		"service_code": "22.01",
		"service_description": "Serviços de exploração de rodovia mediante cobrança de preço ou pedágio dos usuários, envolvendo execução de serviços de conservação, manutenção, melhoramentos para adequação de capacidade e segurança de trânsito, operação, monitoração, assistência aos usuários e outros serviços definidos em contratos, atos de concessão ou de permissão ou em normas oficiais."
	},
	"5222200": {
		"cnae_description": "Terminais rodoviários e ferroviários",
		"service_code": "20.03",
		"service_description": "Serviços de Terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações logísticas e congêneres"
	},
	"5223100": {
		"cnae_description": "Estacionamento de veículos",
		"service_code": "11.01",
		"service_description": "Guarda e estacionamento de veículos terrestres automotores, de aeronaves e de embarcações."
	},
	"5229001": {
		"cnae_description": "Serviços de apoio ao transporte por táxi, inclusive centrais de chamada",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5229002": {
		"cnae_description": "Serviços de reboque de veículos",
		"service_code": "16.01",
		"service_description": "Serviços de transporte de natureza municipal."
	},
	"5229099": {
		"cnae_description": "Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente",
		"service_code": "11.03",
		"service_description": "Escolta, inclusive de veículos e cargas."
	},
	"5231101": {
		"cnae_description": "Administração da infra-estrutura portuária",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5231102": {
		"cnae_description": "Operações de terminais",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5232000": {
		"cnae_description": "Atividades de agenciamento marítimo",
		"service_code": "10.06",
		"service_description": "Agenciamento marítimo."
	},
	"5239700": {
		"cnae_description": "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"5240101": {
		"cnae_description": "Operação dos aeroportos e campos de aterrissagem",
		"service_code": "20.02",
		"service_description": "Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres."
	},
	"5240199": {
		"cnae_description": "Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem",
		"service_code": "20.02",
		"service_description": "Serviços aeroportuários, utilização de aeroporto, movimentação de passageiros, armazenagem de qualquer natureza, capatazia, movimentação de aeronaves, serviços de apoio aeroportuários, serviços acessórios, movimentação de mercadorias, logística e congêneres."
	},
	"5250801": {
		"cnae_description": "Comissaria de despachos",
		"service_code": "33.01",
		"service_description": "Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres."
	},
	"5250802": {
		"cnae_description": "Atividades de despachantes aduaneiros",
		"service_code": "33.01",
		"service_description": "Serviços de desembaraço aduaneiro, comissários, despachantes e congêneres."
	},
	"5250803": {
		"cnae_description": "Agenciamento de cargas, exceto para o transporte marítimo",
		"service_code": "10.05",
		"service_description": "Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios."
	},
	"5250804": {
		"cnae_description": "Organização logística do transporte de carga",
		"service_code": "11.04",
		"service_description": "Armazenamento, depósito, carga, descarga, arrumação e guarda de bens de qualquer espécie"
	},
	"5250805": {
		"cnae_description": "OPERADOR DE TRANSPORTE MULTIMODAL OTM",
		"service_code": "20.03",
		"service_description": "Serviços de Terminais rodoviários, ferroviários, metroviários, movimentação de passageiros, mercadorias, inclusive suas operações logísticas e congêneres"
	},
	"5310501": {
		"cnae_description": "Atividades do Correio Nacional",
		"service_code": "26.01",
		"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres."
	},
	"5310502": {
		"cnae_description": "Atividades de franqueadas do Correio Nacional",
		"service_code": "26.01",
		"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres."
	},
	"5320201": {
		"cnae_description": "Serviços de malote não realizados pelo Correio Nacional",
		"service_code": "26.01",
		"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres."
	},
	"5320202": {
		"cnae_description": "Serviços de entrega rápida",
		"service_code": "26.01",
		"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres."
	},
	"5510801": {
		"cnae_description": "Hotéis",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5510802": {
		"cnae_description": "Apart-hotéis",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5510803": {
		"cnae_description": "Motéis",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5590601": {
		"cnae_description": "Albergues, exceto assistenciais",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5590602": {
		"cnae_description": "Campings",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5590603": {
		"cnae_description": "Pensões (alojamento)",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5590699": {
		"cnae_description": "Outros alojamentos não especificados anteriormente",
		"service_code": "09.01",
		"service_description": "Hospedagem de qualquer natureza em hotéis, apart-service condominiais, flat, apart-hotéis, hotéis residência, residence-service, suite service, hotelaria marítima, motéis, pensões e congêneres; ocupação por temporada com fornecimento de serviço (o valor da alimentação e gorjeta, quando incluído no preço da diária, fica sujeito ao Imposto Sobre Serviços)."
	},
	"5620102": {
		"cnae_description": "Serviços de alimentação para eventos e recepções – bufê",
		"service_code": "17.11",
		"service_description": "Organização de festas e recepções; bufê (exceto o fornecimento de alimentação e bebidas, que fica sujeito ao ICMS)."
	},
	"5811500": {
		"cnae_description": "Edição de livros",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5812300": {
		"cnae_description": "Edição de jornais",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5813100": {
		"cnae_description": "Edição de revistas",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5819100": {
		"cnae_description": "Edição de cadastros, listas e outros produtos gráficos",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5821200": {
		"cnae_description": "Edição integrada à impressão de livros",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5822100": {
		"cnae_description": "Edição integrada à impressão de jornais",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5823900": {
		"cnae_description": "Edição integrada à impressão de revistas",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5829800": {
		"cnae_description": "Edição integrada à impressão de cadastros, listas e outros produtos gráficos",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"5911101": {
		"cnae_description": "Estúdios cinematográficos",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"5911102": {
		"cnae_description": "Produção de filmes para publicidade",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"5911199": {
		"cnae_description": "Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
		"service_code": "12.13",
		"service_description": "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres."
	},
	"5912001": {
		"cnae_description": "Serviços de dublagem",
		"service_code": "13.02",
		"service_description": "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres."
	},
	"5912002": {
		"cnae_description": "Serviços de mixagem sonora em produção audiovisual",
		"service_code": "13.02",
		"service_description": "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres."
	},
	"5912099": {
		"cnae_description": "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"5913800": {
		"cnae_description": "Distribuição cinematográfica, de vídeo e de programas de televisão",
		"service_code": "10.10",
		"service_description": "Distribuição de bens de terceiros"
	},
	"5914600": {
		"cnae_description": "Atividades de exibição cinematográfica",
		"service_code": "12.16",
		"service_description": "Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres."
	},
	"5920100": {
		"cnae_description": "Atividades de gravação de som e de edição de música",
		"service_code": "13.02",
		"service_description": "Fonografia ou gravação de sons, inclusive trucagem, dublagem, mixagem e congêneres."
	},
	"6021700": {
		"cnae_description": "Atividades de televisão aberta",
		"service_code": "12.13",
		"service_description": "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres."
	},
	"6022502": {
		"cnae_description": "Atividades relacionadas à televisão por assinatura, exceto programadoras",
		"service_code": "10.03",
		"service_description": "Agenciamento, corretagem ou intermediação de direitos da propriedade industrial, artística ou literária."
	},
	"6190601": {
		"cnae_description": "Provedores de acesso às redes de comunicações",
		"service_code": "01.03",
		"service_description": "Processamento de dados e congêneres."
	},
	"6190699": {
		"cnae_description": "Outras atividades de telecomunicações não especificadas anteriormente",
		"service_code": "14.06",
		"service_description": "Instalação e montagem de aparelhos, máquinas e equipamentos, inclusive montagem industrial, prestados ao usuário final, exclusivamente com material por ele fornecido."
	},
	"6201500": {
		"cnae_description": "Desenvolvimento de programas de computador sob encomenda",
		"service_code": "01.08",
		"service_description": "Planejamento, confecção, manutenção e atualização de páginas eletrônicas."
	},
	"6202300": {
		"cnae_description": "Desenvolvimento e licenciamento de programas de computador customizáveis",
		"service_code": "01.05",
		"service_description": "Licenciamento ou cessão de direito de uso de programas de computação."
	},
	"6203100": {
		"cnae_description": "Desenvolvimento e licenciamento de programas de computador não-customizáveis",
		"service_code": "01.04",
		"service_description": "Elaboração de programas de computadores, inclusive de jogos eletrônicos."
	},
	"6204000": {
		"cnae_description": "Consultoria em tecnologia da informação",
		"service_code": "01.06",
		"service_description": "Assessoria e consultoria em informática."
	},
	"6209100": {
		"cnae_description": "Suporte técnico, manutenção e outros serviços em tecnologia da informação",
		"service_code": "01.07",
		"service_description": "Suporte técnico em informática, inclusive instalação, configuração e manutenção de programas de computação e bancos de dados."
	},
	"6311900": {
		"cnae_description": "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet",
		"service_code": "01.03",
		"service_description": "Processamento de dados e congêneres."
	},
	"6319400": {
		"cnae_description": "Portais, provedores de conteúdo e outros serviços de informação na internet",
		"service_code": "01.08",
		"service_description": "Planejamento, confecção, manutenção e atualização de páginas eletrônicas."
	},
	"6391700": {
		"cnae_description": "Agências de notícias",
		"service_code": "10.07",
		"service_description": "Agenciamento de notícias."
	},
	"6399200": {
		"cnae_description": "Outras atividades de prestação de serviços de informação não especificadas anteriormente",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"6421200": {
		"cnae_description": "BANCOS COMERCIAIS",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6422100": {
		"cnae_description": "BANCOS MULTIPLOS, COM CARTEIRA COMERCIAL",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6423900": {
		"cnae_description": "CAIXAS ECONOMICAS",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6424701": {
		"cnae_description": "BANCOS COOPERATIVOS",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6424702": {
		"cnae_description": "COOPERATIVAS CENTRAIS DE CREDITO",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6424703": {
		"cnae_description": "COOPERATIVAS DE CREDITO MUTUO",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6424704": {
		"cnae_description": "COOPERATIVAS DE CREDITO RURAL",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6431000": {
		"cnae_description": "BANCOS MULTIPLOS, SEM CARTEIRA COMERCIAL",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6432800": {
		"cnae_description": "BANCOS DE INVESTIMENTO",
		"service_code": "15.16",
		"service_description": "Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral."
	},
	"6433600": {
		"cnae_description": "BANCOS DE DESENVOLVIMENTO",
		"service_code": "15.16",
		"service_description": "Emissão, reemissão, liquidação, alteração, cancelamento e baixa de ordens de pagamento, ordens de crédito e similares, por qualquer meio ou processo; serviços relacionados à transferência de valores, dados, fundos, pagamentos e similares, inclusive entre contas em geral."
	},
	"6434400": {
		"cnae_description": "AGENCIAS DE FOMENTO",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6435201": {
		"cnae_description": "SOCIEDADES DE CREDITO IMOBILIARIO",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6435202": {
		"cnae_description": "ASSOCIACOES DE POUPANCA E EMPRESTIMO",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6435203": {
		"cnae_description": "COMPANHIAS HIPOTECARIAS",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6436100": {
		"cnae_description": "SOCIEDADES DE CREDITO, FINANCIAMENTO E INVESTIMENTO – FINANCEIRAS",
		"service_code": "15.08",
		"service_description": "Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins."
	},
	"6437900": {
		"cnae_description": "SOCIEDADES DE CREDITO AO MICROEMPREENDEDOR",
		"service_code": "15.08",
		"service_description": "Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins."
	},
	"6438701": {
		"cnae_description": "BANCOS DE CAMBIO",
		"service_code": "15.13",
		"service_description": "Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos à carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio."
	},
	"6438799": {
		"cnae_description": "OUTRAS INSTITUICOES DE INTERMEDIACAO NÃO-MONETARIA NAO ESPECIFIDAS ANTERIORMENTE",
		"service_code": "15.13",
		"service_description": "Serviços relacionados a operações de câmbio em geral, edição, alteração, prorrogação, cancelamento e baixa de contrato de câmbio; emissão de registro de exportação ou de crédito; cobrança ou depósito no exterior; emissão, fornecimento e cancelamento de cheques de viagem; fornecimento, transferência, cancelamento e demais serviços relativos à carta de crédito de importação, exportação e garantias recebidas; envio e recebimento de mensagens em geral relacionadas a operações de câmbio."
	},
	"6440900": {
		"cnae_description": "ARRENDAMENTO MERCANTIL",
		"service_code": "15.09",
		"service_description": "Arrendamento mercantil (leasing) de quaisquer bens, inclusive cessão de direitos e obrigações, substituição de garantia, alteração, cancelamento e registro de contrato, e demais serviços relacionados ao arrendamento mercantil (leasing)."
	},
	"6450600": {
		"cnae_description": "SOCIEDADES DE CAPITALIZACAO",
		"service_code": "15.07",
		"service_description": "Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e a rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo."
	},
	"6470101": {
		"cnae_description": "FUNDOS DE INVESTIMENTO, EXCETO PREVIDENCIÁRIOS E IMOBILIÁRIOS",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6470102": {
		"cnae_description": "FUNDOS DE INVESTIMENTO PREVIDENCIARIOS",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6470103": {
		"cnae_description": "FUNDOS DE INVESTIMENTO IMOBILIARIOS",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6491300": {
		"cnae_description": "Sociedades de fomento mercantil – factoring",
		"service_code": "17.23",
		"service_description": "Assessoria, análise, avaliação, atendimento, consulta, cadastro, seleção, gerenciamento de informações, administração de contas a receber ou a pagar e em geral, relacionados a operações de faturização (factoring)."
	},
	"6493000": {
		"cnae_description": "Administração de consórcios para aquisição de bens e direitos",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6499901": {
		"cnae_description": "CLUBES DE INVESTIMENTO",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6499902": {
		"cnae_description": "SOCIEDADES DE INVESTIMENTO",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6499904": {
		"cnae_description": "CAIXAS DE FINANCIAMENTO DE CORPORACOES",
		"service_code": "15.18",
		"service_description": "Serviços relacionados a crédito imobiliário, avaliação e vistoria de imóvel ou obra, análise técnica e jurídica, emissão, reemissão, alteração, transferência e renegociação de contrato, emissão e reemissão do termo de quitação e demais serviços relacionados a crédito imobiliário."
	},
	"6499905": {
		"cnae_description": "CONCESSAO DE CREDITO PELAS OSCIP",
		"service_code": "15.08",
		"service_description": "Emissão, reemissão, alteração, cessão, substituição, cancelamento e registro de contrato de crédito; estudo, análise e avaliação de operações de crédito; emissão, concessão, alteração ou contratação de aval, fiança, anuência e congêneres; serviços relativos à abertura de crédito, para quaisquer fins."
	},
	"6499999": {
		"cnae_description": "OUTRAS ATIVIDADES DE SERVICOS FINANCEIROS NAO ESPECIFICADAS ANTERIORMENTE",
		"service_code": "15.12",
		"service_description": "Custódia em geral, inclusive de títulos e valores mobiliários."
	},
	"6511102": {
		"cnae_description": "Planos de auxílio-funeral",
		"service_code": "25.03",
		"service_description": "Planos ou convênio funerários."
	},
	"6550200": {
		"cnae_description": "Planos de saúde",
		"service_code": "05.09",
		"service_description": "Planos de atendimento e assistência médico veterinária."
	},
	"6611801": {
		"cnae_description": "Bolsa de valores",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6611802": {
		"cnae_description": "Bolsa de mercadorias",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6611803": {
		"cnae_description": "Bolsa de mercadorias e futuros",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6611804": {
		"cnae_description": "Administração de mercados de balcão organizados",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6612601": {
		"cnae_description": "Corretoras de títulos e valores mobiliários",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"6612602": {
		"cnae_description": "Distribuidoras de títulos e valores mobiliários",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"6612603": {
		"cnae_description": "Corretoras de câmbio",
		"service_code": "10.01",
		"service_description": "Agenciamento, corretagem ou intermediação de câmbio, de seguros, de cartões de crédito, de planos de saúde e de planos de previdência privada."
	},
	"6612604": {
		"cnae_description": "Corretoras de contratos de mercadorias",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"6612605": {
		"cnae_description": "Agentes de investimentos em aplicações financeiras",
		"service_code": "17.20",
		"service_description": "Consultoria e assessoria econômica ou financeira."
	},
	"6613400": {
		"cnae_description": "Administração de cartões de crédito",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6619301": {
		"cnae_description": "SERVIÇOS DE LIQUIDAÇÃO E CUSTÓDIA",
		"service_code": "15.12",
		"service_description": "Custódia em geral, inclusive de títulos e valores mobiliários."
	},
	"6619302": {
		"cnae_description": "CORRESPONDENTES DE INSTITUICOES FINANCEIRAS",
		"service_code": "15.10",
		"service_description": "Serviços relacionados a cobranças, recebimentos ou pagamentos em geral, de títulos quaisquer, de contas ou carnês, de câmbio, de tributos e por conta de terceiros, inclusive os efetuados por meio eletrônico, automático ou por máquinas de atendimento; fornecimento de posição de cobrança recebimento ou pagamento; emissão de carnês, fichas de compensação, impressos e documentos em geral."
	},
	"6619303": {
		"cnae_description": "REPRESENTACOES DE BANCOS ESTRANGEIROS",
		"service_code": "10.09",
		"service_description": "Representação de qualquer natureza, inclusive comercial."
	},
	"6619304": {
		"cnae_description": "CAIXAS ELETRONICOS",
		"service_code": "15.07",
		"service_description": "Acesso, movimentação, atendimento e consulta a contas em geral, por qualquer meio ou processo, inclusive por telefone, fac-símile, internet e telex, acesso a terminais de atendimento, inclusive vinte e quatro horas; acesso a outro banco e a rede compartilhada; fornecimento de saldo, extrato e demais informações relativas a contas em geral, por qualquer meio ou processo."
	},
	"6619305": {
		"cnae_description": "OPERADORAS DE CARTOES DE DEBITO",
		"service_code": "15.01",
		"service_description": "Administração de fundos quaisquer, de consórcio, de cartão de crédito ou débito e congêneres, de carteira de clientes, de cheques pré-datados e congêneres."
	},
	"6619399": {
		"cnae_description": "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"6621501": {
		"cnae_description": "Peritos e avaliadores de seguros",
		"service_code": "28.01",
		"service_description": "Serviços de avaliação de bens e serviços de qualquer natureza."
	},
	"6621502": {
		"cnae_description": "Auditoria e consultoria atuarial",
		"service_code": "17.20",
		"service_description": "Consultoria e assessoria econômica ou financeira."
	},
	"6622300": {
		"cnae_description": "Corretores e agentes de seguros, de planos de previdência complementar e de saúde",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"6629100": {
		"cnae_description": "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriorme",
		"service_code": "18.01",
		"service_description": "Serviços de regulação de sinistros vinculados a contratos de seguros; inspeção e avaliação de riscos para cobertura de contratos de seguros; prevenção e gerência de riscos seguráveis e congêneres."
	},
	"6630400": {
		"cnae_description": "Atividades de administração de fundos por contrato ou comissão",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6821801": {
		"cnae_description": "Corretagem na compra e venda e avaliação de imóveis",
		"service_code": "28.01",
		"service_description": "Serviços de avaliação de bens e serviços de qualquer natureza."
	},
	"6821802": {
		"cnae_description": "Corretagem no aluguel de imóveis",
		"service_code": "10.05",
		"service_description": "Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios."
	},
	"6822600": {
		"cnae_description": "Gestão e administração da propriedade imobiliária",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"6911701": {
		"cnae_description": "Serviços advocatícios",
		"service_code": "17.14",
		"service_description": "Advocacia."
	},
	"6911702": {
		"cnae_description": "Atividades auxiliares da justiça",
		"service_code": "17.15",
		"service_description": "Arbitragem de qualquer espécie, inclusive jurídica."
	},
	"6911703": {
		"cnae_description": "Agente de propriedade industrial",
		"service_code": "10.03",
		"service_description": "Agenciamento, corretagem ou intermediação de direitos da propriedade industrial, artística ou literária."
	},
	"6912500": {
		"cnae_description": "Cartórios",
		"service_code": "21.01",
		"service_description": "Serviços de registros públicos, cartorários e notariais."
	},
	"6920601": {
		"cnae_description": "Atividades de contabilidade",
		"service_code": "17.19",
		"service_description": "Contabilidade, inclusive serviços técnicos e auxiliares."
	},
	"6920602": {
		"cnae_description": "Atividades de consultoria e auditoria contábil e tributária",
		"service_code": "17.16",
		"service_description": "Auditoria."
	},
	"7020400": {
		"cnae_description": "Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica",
		"service_code": "35.01",
		"service_description": "Serviços de reportagem, assessoria de imprensa, jornalismo e relações públicas."
	},
	"7111100": {
		"cnae_description": "Serviços de arquitetura",
		"service_code": "07.01",
		"service_description": "Engenharia, agronomia, agrimensura, arquitetura, geologia, urbanismo, paisagismo e congêneres."
	},
	"7112000": {
		"cnae_description": "Serviços de engenharia",
		"service_code": "28.01",
		"service_description": "Serviços de avaliação de bens e serviços de qualquer natureza."
	},
	"7119701": {
		"cnae_description": "Serviços de cartografia, topografia e geodésia",
		"service_code": "07.20",
		"service_description": "Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres."
	},
	"7119702": {
		"cnae_description": "Atividades de estudos geológicos",
		"service_code": "07.20",
		"service_description": "Aerofotogrametria (inclusive interpretação), cartografia, mapeamento, levantamentos topográficos, batimétricos, geográficos, geodésicos, geológicos, geofísicos e congêneres."
	},
	"7119703": {
		"cnae_description": "Serviços de desenho técnico relacionados à arquitetura e engenharia",
		"service_code": "32.01",
		"service_description": "Serviços de desenhos técnicos."
	},
	"7119704": {
		"cnae_description": "Serviços de perícia técnica relacionados à segurança do trabalho",
		"service_code": "17.09",
		"service_description": "Perícias, laudos, exames técnicos e análises técnicas."
	},
	"7119799": {
		"cnae_description": "Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente",
		"service_code": "31.01",
		"service_description": "Serviços técnicos em edificações, eletrônica, eletrotécnica, mecânica, telecomunicações e congêneres."
	},
	"7120100": {
		"cnae_description": "Testes e análises técnicas",
		"service_code": "17.09",
		"service_description": "Perícias, laudos, exames técnicos e análises técnicas."
	},
	"7210000": {
		"cnae_description": "Pesquisa e desenvolvimento experimental em ciências físicas e naturais",
		"service_code": "30.01",
		"service_description": "Serviços de biologia, biotecnologia e química."
	},
	"7220700": {
		"cnae_description": "Pesquisa e desenvolvimento experimental em ciências sociais e humanas",
		"service_code": "02.01",
		"service_description": "Serviços de pesquisas e desenvolvimento de qualquer natureza."
	},
	"7311400": {
		"cnae_description": "Agências de publicidade",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"7312200": {
		"cnae_description": "Agenciamento de espaços para publicidade, exceto em veículos de comunicação",
		"service_code": "10.08",
		"service_description": "Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios."
	},
	"7319001": {
		"cnae_description": "Criação e montagem de estandes para feiras e exposições",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"7319002": {
		"cnae_description": "Promoção de vendas",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"7319003": {
		"cnae_description": "Marketing direto",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"7319004": {
		"cnae_description": "Consultoria em publicidade",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"7319099": {
		"cnae_description": "Outras atividades de publicidade não especificadas anteriormente",
		"service_code": "17.06",
		"service_description": "Propaganda e publicidade, inclusive promoção de vendas, planejamento de campanhas ou sistemas de publicidade, elaboração de desenhos, textos e demais materiais publicitários."
	},
	"7320300": {
		"cnae_description": "Pesquisas de mercado e de opinião pública",
		"service_code": "17.21",
		"service_description": "Estatística."
	},
	"7410201": {
		"cnae_description": "Design",
		"service_code": "39.01",
		"service_description": "Serviços de ourivesaria e lapidação (quando o material for fornecido pelo tomador do serviço)."
	},
	"7410202": {
		"cnae_description": "Decoração de interiores",
		"service_code": "07.11",
		"service_description": "Decoração e jardinagem, inclusive corte e poda de árvores."
	},
	"7420001": {
		"cnae_description": "Atividades de produção de fotografias, exceto aérea e submarina",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"7420002": {
		"cnae_description": "Atividades de produção de fotografias aéreas e submarinas",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"7420003": {
		"cnae_description": "Laboratórios fotográficos",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"7420004": {
		"cnae_description": "Filmagem de festas e eventos",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"7420005": {
		"cnae_description": "Serviços de microfilmagem",
		"service_code": "13.04",
		"service_description": "Reprografia, microfilmagem e digitalização."
	},
	"7490101": {
		"cnae_description": "Serviços de tradução, interpretação e similares",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"7490102": {
		"cnae_description": "Escafandria e mergulho",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"7490103": {
		"cnae_description": "Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"7490104": {
		"cnae_description": "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários",
		"service_code": "10.08",
		"service_description": "Agenciamento de publicidade e propaganda, inclusive o agenciamento de veiculação por quaisquer meios."
	},
	"7490105": {
		"cnae_description": "Agenciamento de profissionais para atividades esportivas, culturais e artísticas",
		"service_code": "37.01",
		"service_description": "Serviços de artistas, atletas, modelos e manequins."
	},
	"7490199": {
		"cnae_description": "Outras atividades profissionais, científicas e técnicas não especificadas anteriormente",
		"service_code": "36.01",
		"service_description": "Serviços de meteorologia."
	},
	"7500100": {
		"cnae_description": "Atividades veterinárias",
		"service_code": "05.07",
		"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres."
	},
	"7732202": {
		"cnae_description": "Aluguel de andaimes",
		"service_code": "03.05",
		"service_description": "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário."
	},
	"7739003": {
		"cnae_description": "Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes",
		"service_code": "03.05",
		"service_description": "Cessão de andaimes, palcos, coberturas e outras estruturas de uso temporário."
	},
	"7740300": {
		"cnae_description": "Gestão de ativos intangíveis não-financeiros",
		"service_code": "3.02",
		"service_description": "Cessão de direito de uso de marcas e de sinais de propaganda."
	},
	"7810800": {
		"cnae_description": "Seleção e agenciamento de mão-de-obra",
		"service_code": "17.04",
		"service_description": "Recrutamento, agenciamento, seleção e colocação de mão de obra"
	},
	"7820500": {
		"cnae_description": "Locação de mão-de-obra temporária",
		"service_code": "17.05",
		"service_description": "Fornecimento de mão de obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço."
	},
	"7830200": {
		"cnae_description": "Fornecimento e gestão de recursos humanos para terceiros",
		"service_code": "17.05",
		"service_description": "Fornecimento de mão de obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço."
	},
	"7911200": {
		"cnae_description": "Agências de viagens",
		"service_code": "09.02",
		"service_description": "Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
	},
	"7912100": {
		"cnae_description": "Operadores turísticos",
		"service_code": "09.03",
		"service_description": "Guias de turismo."
	},
	"7990200": {
		"cnae_description": "Serviços de reservas e outros serviços de turismo não especificados anteriormente",
		"service_code": "09.02",
		"service_description": "Agenciamento, organização, promoção, intermediação e execução de programas de turismo, passeios, viagens, excursões, hospedagens e congêneres."
	},
	"8011101": {
		"cnae_description": "Atividades de vigilância e segurança privada",
		"service_code": "11.02",
		"service_description": "Vigilância, segurança ou monitoramento de bens e pessoas."
	},
	"8011102": {
		"cnae_description": "Serviços de adestramento de cães de guarda",
		"service_code": "05.08",
		"service_description": "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres."
	},
	"8012900": {
		"cnae_description": "Atividades de transporte de valores",
		"service_code": "26.01",
		"service_description": "Serviços de coleta, remessa ou entrega de correspondências, documentos, objetos, bens ou valores, inclusive pelos correios e suas agências franqueadas; courrier e congêneres."
	},
	"8020000": {
		"cnae_description": "Atividades de monitoramento de sistemas de segurança",
		"service_code": "11.02",
		"service_description": "Vigilância, segurança ou monitoramento de bens e pessoas."
	},
	"8030700": {
		"cnae_description": "Atividades de investigação particular",
		"service_code": "34.01",
		"service_description": "Serviços de investigações particulares, detetives e congêneres."
	},
	"8111700": {
		"cnae_description": "Serviços combinados para apoio a edifícios, exceto condomínios prediais",
		"service_code": "17.05",
		"service_description": "Fornecimento de mão de obra, mesmo em caráter temporário, inclusive de empregados ou trabalhadores, avulsos ou temporários, contratados pelo prestador de serviço."
	},
	"8121400": {
		"cnae_description": "Limpeza em prédios e em domicílios",
		"service_code": "07.10",
		"service_description": "Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres."
	},
	"8122200": {
		"cnae_description": "Imunização e controle de pragas urbanas",
		"service_code": "07.13",
		"service_description": "Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres."
	},
	"8129000": {
		"cnae_description": "Atividades de limpeza não especificadas anteriormente",
		"service_code": "07.10",
		"service_description": "Limpeza, manutenção e conservação de vias e logradouros públicos, imóveis, chaminés, piscinas, parques, jardins e congêneres."
	},
	"8130300": {
		"cnae_description": "Atividades paisagísticas",
		"service_code": "07.11",
		"service_description": "Decoração e jardinagem, inclusive corte e poda de árvores."
	},
	"8211300": {
		"cnae_description": "Serviços combinados de escritório e apoio administrativo",
		"service_code": "17.03",
		"service_description": "Planejamento, coordenação, programação ou organização técnica, financeira ou administrativa."
	},
	"8219901": {
		"cnae_description": "Fotocópias",
		"service_code": "13.04",
		"service_description": "Reprografia, microfilmagem e digitalização."
	},
	"8219999": {
		"cnae_description": "Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"8220200": {
		"cnae_description": "Atividades de teleatendimento",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"8230001": {
		"cnae_description": "Serviços de organização de feiras, congressos, exposições e festas",
		"service_code": "17.10",
		"service_description": "Planejamento, organização e administração de feiras, exposições, congressos e congêneres."
	},
	"8230002": {
		"cnae_description": "Casas de festas e eventos",
		"service_code": "03.03",
		"service_description": "Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza"
	},
	"8291100": {
		"cnae_description": "Atividades de cobrança e informações cadastrais",
		"service_code": "17.22",
		"service_description": "Cobrança em geral."
	},
	"8292000": {
		"cnae_description": "Envasamento e empacotamento sob contrato",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"8299701": {
		"cnae_description": "Medição de consumo de energia elétrica, gás e água",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"8299702": {
		"cnae_description": "Emissão de vales-alimentação, vales-transporte e similares",
		"service_code": "10.05",
		"service_description": "Agenciamento, corretagem ou intermediação de bens móveis ou imóveis, não abrangidos em outros itens ou subitens, inclusive aqueles realizados no âmbito de Bolsas de Mercadorias e Futuros, por quaisquer meios."
	},
	"8299703": {
		"cnae_description": "Serviços de gravação de carimbos, exceto confecção",
		"service_code": "24.01",
		"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres."
	},
	"8299704": {
		"cnae_description": "Leiloeiros independentes",
		"service_code": "17.13",
		"service_description": "Leilão e congêneres."
	},
	"8299705": {
		"cnae_description": "Serviços de levantamento de fundos sob contrato",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"8299706": {
		"cnae_description": "Casas lotéricas",
		"service_code": "19.01",
		"service_description": "Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres."
	},
	"8299799": {
		"cnae_description": "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente",
		"service_code": "17.02",
		"service_description": "Datilografia, digitação, estenografia, expediente, secretaria em geral, resposta audível, redação, edição, interpretação, revisão, tradução, apoio e infra estrutura administrativa e congêneres."
	},
	"8511200": {
		"cnae_description": "Educação infantil – creche",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8512100": {
		"cnae_description": "Educação infantil – pré-escola",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8513900": {
		"cnae_description": "Ensino fundamental",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8520100": {
		"cnae_description": "Ensino médio",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8531700": {
		"cnae_description": "Educação superior – graduação",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8532500": {
		"cnae_description": "Educação superior – graduação e pós- graduação",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8533300": {
		"cnae_description": "Educação superior – pós-graduação e extensão",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8541400": {
		"cnae_description": "Educação profissional de nível técnico",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8542200": {
		"cnae_description": "Educação profissional de nível tecnológico",
		"service_code": "08.01",
		"service_description": "Ensino regular pré escolar, fundamental, médio e superior."
	},
	"8550302": {
		"cnae_description": "Atividades de apoio à educação, exceto caixas escolares",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8591100": {
		"cnae_description": "Ensino de esportes",
		"service_code": "06.04",
		"service_description": "Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas."
	},
	"8592901": {
		"cnae_description": "Ensino de dança",
		"service_code": "06.04",
		"service_description": "Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas."
	},
	"8592902": {
		"cnae_description": "Ensino de artes cênicas, exceto dança",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8592903": {
		"cnae_description": "Ensino de música",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8592999": {
		"cnae_description": "Ensino de arte e cultura não especificado anteriormente",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8593700": {
		"cnae_description": "Ensino de idiomas",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599601": {
		"cnae_description": "Formação de condutores",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599602": {
		"cnae_description": "Cursos de pilotagem",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599603": {
		"cnae_description": "Treinamento em informática",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599604": {
		"cnae_description": "Treinamento em desenvolvimento profissional e gerencial",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599605": {
		"cnae_description": "Cursos preparatórios para concursos",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"8599699": {
		"cnae_description": "Outras atividades de ensino não especificadas anteriormente",
		"service_code": "17.24",
		"service_description": "Apresentação de palestras, conferências, seminários e congêneres."
	},
	"8610101": {
		"cnae_description": "Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8610102": {
		"cnae_description": "Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8621601": {
		"cnae_description": "UTI móvel",
		"service_code": "04.21",
		"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres."
	},
	"8621602": {
		"cnae_description": "Serviços móveis de atendimento a urgências, exceto por UTI móvel",
		"service_code": "04.21",
		"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres."
	},
	"8622400": {
		"cnae_description": "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências",
		"service_code": "04.21",
		"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres."
	},
	"8630501": {
		"cnae_description": "Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8630502": {
		"cnae_description": "Atividade médica ambulatorial com recursos para realização de exames complementares",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8630503": {
		"cnae_description": "Atividade consultas",
		"service_code": "médica",
		"service_description": "ambulatorial"
	},
	"8630504": {
		"cnae_description": "Atividade odontológica",
		"service_code": "04.12",
		"service_description": "Odontologia."
	},
	"8630506": {
		"cnae_description": "Serviços de vacinação e imunização humana",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8630507": {
		"cnae_description": "Atividades de reprodução humana assistida",
		"service_code": "04.19",
		"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
	},
	"8630599": {
		"cnae_description": "Atividades de atenção ambulatorial não especificadas anteriormente",
		"service_code": "04.01",
		"service_description": "Medicina e biomedicina."
	},
	"8640201": {
		"cnae_description": "Laboratórios de anatomia patológica e citológica",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8640202": {
		"cnae_description": "Laboratórios clínicos",
		"service_code": "30.01",
		"service_description": "Serviços de biologia, biotecnologia e química."
	},
	"8640203": {
		"cnae_description": "Serviços de diálise e nefrologia",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8640204": {
		"cnae_description": "Serviços de tomografia",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640205": {
		"cnae_description": "Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640206": {
		"cnae_description": "Serviços de ressonância magnética",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640207": {
		"cnae_description": "Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640208": {
		"cnae_description": "Serviços de diagnóstico por registro gráfico – ECG, EEG e outros exames análogos",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640209": {
		"cnae_description": "Serviços de diagnóstico por métodos ópticos – endoscopia e outros exames análogos",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640210": {
		"cnae_description": "Serviços de quimioterapia",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640211": {
		"cnae_description": "Serviços de radioterapia",
		"service_code": "04.02",
		"service_description": "Análises clínicas, patologia, eletricidade médica, radioterapia, quimioterapia, ultra sonografia, ressonância magnética, radiologia, tomografia e congêneres."
	},
	"8640212": {
		"cnae_description": "Serviços de hemoterapia",
		"service_code": "04.19",
		"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
	},
	"8640213": {
		"cnae_description": "Serviços de litotripsia",
		"service_code": "04.03",
		"service_description": "Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos socorros, ambulatórios e congêneres."
	},
	"8640214": {
		"cnae_description": "Serviços de bancos de células e tecidos humanos",
		"service_code": "04.19",
		"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
	},
	"8640299": {
		"cnae_description": "Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente",
		"service_code": "04.09",
		"service_description": "Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental."
	},
	"8650001": {
		"cnae_description": "Atividades de enfermagem",
		"service_code": "04.06",
		"service_description": "Enfermagem, inclusive serviços auxiliares."
	},
	"8650002": {
		"cnae_description": "Atividades de profissionais da nutrição",
		"service_code": "04.10",
		"service_description": "Nutrição."
	},
	"8650003": {
		"cnae_description": "Atividades de psicologia e psicanálise",
		"service_code": "04.16",
		"service_description": "Psicologia."
	},
	"8650004": {
		"cnae_description": "Atividades de fisioterapia",
		"service_code": "04.08",
		"service_description": "Terapia ocupacional, fisioterapia e fonoaudiologia."
	},
	"8650005": {
		"cnae_description": "Atividades de terapia ocupacional",
		"service_code": "04.08",
		"service_description": "Terapia ocupacional, fisioterapia e fonoaudiologia."
	},
	"8650006": {
		"cnae_description": "Atividades de fonoaudiologia",
		"service_code": "04.08",
		"service_description": "Terapia ocupacional, fisioterapia e fonoaudiologia."
	},
	"8650007": {
		"cnae_description": "Atividades de terapia de nutrição enteral e parenteral",
		"service_code": "04.09",
		"service_description": "Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental."
	},
	"8650099": {
		"cnae_description": "Atividades de profissionais da área de saúde não especificadas anteriormente",
		"service_code": "04.13",
		"service_description": "Ortóptica."
	},
	"8660700": {
		"cnae_description": "Atividades de apoio à gestão de saúde",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"8690901": {
		"cnae_description": "Atividades de práticas integrativas e complementares em saúde humana",
		"service_code": "04.09",
		"service_description": "Terapias de qualquer espécie destinadas ao tratamento físico, orgânico e mental."
	},
	"8690902": {
		"cnae_description": "Atividades de bancos de leite humano",
		"service_code": "04.19",
		"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
	},
	"8690903": {
		"cnae_description": "Atividades de acumputura",
		"service_code": "04.05",
		"service_description": "Acupuntura."
	},
	"8690904": {
		"cnae_description": "Atividades de podologia",
		"service_code": "06.01",
		"service_description": "Barbearia, cabeleireiros, manicuros, pedicuros e congêneres."
	},
	"8690999": {
		"cnae_description": "Outras atividades de atenção à saúde humana não especificadas anteriormente",
		"service_code": "04.19",
		"service_description": "Bancos de sangue, leite, pele, olhos, óvulos, sêmen e congêneres."
	},
	"8711501": {
		"cnae_description": "Clínicas e residências geriátricas",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8711502": {
		"cnae_description": "Instituições de longa permanência para idosos",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8711503": {
		"cnae_description": "Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8711504": {
		"cnae_description": "Centros de apoio a pacientes com câncer e com AIDS",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8711505": {
		"cnae_description": "Condomínios residenciais para idosos",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8712300": {
		"cnae_description": "Atividades de fornecimento de infra-estrutura de apoio e assistência a paciente no domicílio",
		"service_code": "04.21",
		"service_description": "Unidade de atendimento, assistência ou tratamento móvel e congêneres."
	},
	"8720401": {
		"cnae_description": "Atividades de centros de assistência psicossocial",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8720499": {
		"cnae_description": "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química não especificadas anteriormente",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8730101": {
		"cnae_description": "Orfanatos",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8730102": {
		"cnae_description": "Albergues assistencias",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8730199": {
		"cnae_description": "Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente",
		"service_code": "04.17",
		"service_description": "Casas de repouso e de recuperação, creches, asilos e congêneres."
	},
	"8800600": {
		"cnae_description": "Serviços de assistência social sem alojamento",
		"service_code": "27.01",
		"service_description": "Serviços de assistência social."
	},
	"9001901": {
		"cnae_description": "Produção teatral",
		"service_code": "12.13",
		"service_description": "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres."
	},
	"9001902": {
		"cnae_description": "Produção musical",
		"service_code": "12.16",
		"service_description": "Exibição de filmes, entrevistas, musicais, espetáculos, shows, concertos, desfiles, óperas, competições esportivas, de destreza intelectual ou congêneres."
	},
	"9001903": {
		"cnae_description": "Produção de espetáculos de dança",
		"service_code": "12.15",
		"service_description": "Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres."
	},
	"9001904": {
		"cnae_description": "Produção de espetáculos circenses, de marionetes e similares",
		"service_code": "12.13",
		"service_description": "Produção, mediante ou sem encomenda prévia, de eventos, espetáculos, entrevistas, shows, ballet, danças, desfiles, bailes, teatros, óperas, concertos, recitais, festivais e congêneres."
	},
	"9001905": {
		"cnae_description": "Produção de espetáculos de rodeios, vaquejadas e similares",
		"service_code": "12.10",
		"service_description": "Corridas e competições de animais."
	},
	"9001906": {
		"cnae_description": "Atividades de sonorização e de iluminação",
		"service_code": "12.14",
		"service_description": "Fornecimento de música para ambientes fechados ou não, mediante transmissão por qualquer processo."
	},
	"9001999": {
		"cnae_description": "Artes cênicas, espetáculos e atividades complementares não especificados anteriormente",
		"service_code": "12.05",
		"service_description": "Parques de diversões, centros de lazer e congêneres."
	},
	"9002701": {
		"cnae_description": "Atividades de artistas plásticos, jornalistas independentes e escritores",
		"service_code": "40.01",
		"service_description": "Obras de arte sob encomenda."
	},
	"9002702": {
		"cnae_description": "Restauração de obras de arte",
		"service_code": "14.05",
		"service_description": "Restauração, recondicionamento, acondicionamento, pintura, beneficiamento, lavagem, secagem, tingimento, galvanoplastia, anodização, corte, recorte, polimento, plastificação e congêneres, de objetos quaisquer."
	},
	"9003500": {
		"cnae_description": "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas",
		"service_code": "03.03",
		"service_description": "Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza"
	},
	"9101500": {
		"cnae_description": "Atividades de bibliotecas e arquivos",
		"service_code": "29.01",
		"service_description": "Serviços de biblioteconomia."
	},
	"9102301": {
		"cnae_description": "Atividades de museus e de exploração de lugares e prédios históricos e atrações similares",
		"service_code": "38.01",
		"service_description": "Serviços de museologia."
	},
	"9102302": {
		"cnae_description": "Restauração e conservação de lugares e prédios históricos",
		"service_code": "07.05",
		"service_description": "Reparação, conservação e reforma de edifícios, estradas, pontes, portos e congêneres (exceto o fornecimento de mercadorias produzidas pelo prestador dos serviços, fora do local da prestação dos serviços, que fica sujeito ao ICMS)."
	},
	"9103100": {
		"cnae_description": "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental",
		"service_code": "12.05",
		"service_description": "Parques de diversões, centros de lazer e congêneres."
	},
	"9200301": {
		"cnae_description": "Casas de bingo",
		"service_code": "19.01",
		"service_description": "Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres."
	},
	"9200302": {
		"cnae_description": "Exploração de apostas em corridas de cavalos",
		"service_code": "12.10",
		"service_description": "Corridas e competições de animais."
	},
	"9200399": {
		"cnae_description": "Exploração de jogos de azar e apostas não especificados anteriormente",
		"service_code": "19.01",
		"service_description": "Serviços de distribuição e venda de bilhetes e demais produtos de loteria, bingos, cartões, pules ou cupons de apostas, sorteios, prêmios, inclusive os decorrentes de títulos de capitalização e congêneres."
	},
	"9311500": {
		"cnae_description": "Gestão de instalações de esportes",
		"service_code": "3.03",
		"service_description": "Exploração de salões de festas, centro de convenções, escritórios virtuais, stands, quadras esportivas, estádios, auditórios, casas de espetáculos, parques de diversões, canchas e congêneres, para realização de eventos ou negócios de qualquer natureza"
	},
	"9312300": {
		"cnae_description": "CLUBES SOCIAIS, ESPORTIVOS E SIMILARES",
		"service_code": "08.02",
		"service_description": "Instrução, treinamento, orientação pedagógica e educacional, avaliação de conhecimentos de qualquer natureza."
	},
	"9313100": {
		"cnae_description": "Atividades de condicionamento físico",
		"service_code": "06.04",
		"service_description": "Ginástica, dança, esportes, natação, artes marciais e demais atividades físicas."
	},
	"9319101": {
		"cnae_description": "Produção e promoção de eventos esportivos",
		"service_code": "12.11",
		"service_description": "Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador."
	},
	"9319199": {
		"cnae_description": "Outras atividades esportivas não especificadas anteriormente",
		"service_code": "12.11",
		"service_description": "Competições esportivas ou de destreza física ou intelectual, com ou sem a participação do espectador."
	},
	"9321200": {
		"cnae_description": "Parques de diversão e parques temáticos",
		"service_code": "12.05",
		"service_description": "Parques de diversões, centros de lazer e congêneres."
	},
	"9329801": {
		"cnae_description": "Discotecas, danceterias, salões de dança e similares",
		"service_code": "12.06",
		"service_description": "Boates, taxi dancing e congêneres"
	},
	"9329802": {
		"cnae_description": "Exploração de boliches",
		"service_code": "12.09",
		"service_description": "Bilhares, boliches e diversões eletrônicas ou não."
	},
	"9329803": {
		"cnae_description": "Exploração de jogos de sinuca, bilhar e similares",
		"service_code": "12.09",
		"service_description": "Bilhares, boliches e diversões eletrônicas ou não."
	},
	"9329804": {
		"cnae_description": "Exploração de jogos eletrônicos recreativos",
		"service_code": "12.09",
		"service_description": "Bilhares, boliches e diversões eletrônicas ou não."
	},
	"9329899": {
		"cnae_description": "Outras atividades de recreação e lazer não especificadas anteriormente",
		"service_code": "12.17",
		"service_description": "Recreação e animação, inclusive em festas e eventos de qualquer natureza."
	},
	"9430800": {
		"cnae_description": "Atividades de associação de defesa de direitos sociais",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"9493600": {
		"cnae_description": "Atividades de organizações associativas ligadas à cultura e à arte",
		"service_code": "12.15",
		"service_description": "Desfiles de blocos carnavalescos ou folclóricos, trios elétricos e congêneres."
	},
	"9511800": {
		"cnae_description": "Reparação e manutenção de computadores e de equipamentos periféricos",
		"service_code": "14.02",
		"service_description": "Assistência técnica."
	},
	"9512600": {
		"cnae_description": "Reparação e manutenção de equipamentos de comunicação",
		"service_code": "14.02",
		"service_description": "Assistência técnica."
	},
	"9521500": {
		"cnae_description": "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"9529101": {
		"cnae_description": "Reparação de calçados, bolsas e artigos de viagem",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"9529102": {
		"cnae_description": "Chaveiros",
		"service_code": "24.01",
		"service_description": "Serviços de chaveiros, confecção de carimbos, placas, sinalização visual, banners, adesivos e congêneres."
	},
	"9529103": {
		"cnae_description": "Reparação de relógios",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"9529104": {
		"cnae_description": "Reparação de bicicletas, triciclos e outros veículos não-motorizados",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"9529105": {
		"cnae_description": "Reparação de artigos do mobiliário",
		"service_code": "14.11",
		"service_description": "Tapeçaria e reforma de estofamentos em geral."
	},
	"9529106": {
		"cnae_description": "Reparação de jóias",
		"service_code": "14.01",
		"service_description": "Lubrificação, limpeza, lustração, revisão, carga e recarga, conserto, restauração, blindagem, manutenção e conservação de máquinas, veículos, aparelhos, equipamentos, motores, elevadores ou de qualquer objeto (exceto peças e partes empregadas, que ficam sujeitas ao ICMS)."
	},
	"9529199": {
		"cnae_description": "Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente",
		"service_code": "14.09",
		"service_description": "Alfaiataria e costura, quando o material for fornecido pelo usuário final, exceto aviamento."
	},
	"9601701": {
		"cnae_description": "Lavanderias",
		"service_code": "14.10",
		"service_description": "Tinturaria e lavanderia."
	},
	"9601702": {
		"cnae_description": "Tinturarias",
		"service_code": "14.10",
		"service_description": "Tinturaria e lavanderia."
	},
	"9601703": {
		"cnae_description": "Toalheiros",
		"service_code": "14.10",
		"service_description": "Tinturaria e lavanderia."
	},
	"9602501": {
		"cnae_description": "Cabeleireiros",
		"service_code": "06.01",
		"service_description": "Barbearia, cabeleireiros, manicuros, pedicuros e congêneres."
	},
	"9602502": {
		"cnae_description": "Atividades de estética e outros serviços de cuidados com a beleza",
		"service_code": "06.02",
		"service_description": "Esteticistas, tratamento de pele, depilação e congêneres."
	},
	"9603301": {
		"cnae_description": "Gestão e manutenção de cemitérios",
		"service_code": "25.04",
		"service_description": "Manutenção e conservação de jazigos e cemitérios."
	},
	"9603302": {
		"cnae_description": "Serviços de cremação",
		"service_code": "25.02",
		"service_description": "Cremação de corpos e partes de corpos cadavéricos."
	},
	"9603303": {
		"cnae_description": "Serviços de sepultamento",
		"service_code": "25.01",
		"service_description": "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres."
	},
	"9603304": {
		"cnae_description": "Serviços de funerárias",
		"service_code": "25.01",
		"service_description": "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres."
	},
	"9603305": {
		"cnae_description": "Serviços de somatoconservação",
		"service_code": "25.01",
		"service_description": "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres."
	},
	"9603399": {
		"cnae_description": "Atividades funerárias e serviços relacionados não especificados anteriormente",
		"service_code": "25.01",
		"service_description": "Funerais, inclusive fornecimento de caixão, urna ou esquifes; aluguel de capela; transporte do corpo cadavérico; fornecimento de flores, coroas e outros paramentos; desembaraço de certidão de óbito; fornecimento de véu, essa e outros adornos; embalsamento, embelezamento, conservação ou restauração de cadáveres."
	},
	"9609201": {
		"cnae_description": "Clínicas de estética e similares",
		"service_code": "06.05",
		"service_description": "Centros de emagrecimento, spa e congêneres."
	},
	"9609202": {
		"cnae_description": "Agências matrimoniais",
		"service_code": "10.02",
		"service_description": "Agenciamento, corretagem ou intermediação de títulos em geral, valores mobiliários e contratos quaisquer."
	},
	"9609203": {
		"cnae_description": "Alojamento, higiene e embelezamento de animais",
		"service_code": "05.08",
		"service_description": "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres."
	},
	"9609204": {
		"cnae_description": "Exploração de máquinas de serviços pessoais acionados po moeda",
		"service_code": "13.03",
		"service_description": "Fotografia e cinematografia, inclusive revelação, ampliação, cópia, reprodução, trucagem e congêneres."
	},
	"9609205": {
		"cnae_description": "Atividades de sauna e banhos",
		"service_code": "06.03",
		"service_description": "Banhos, duchas, sauna, massagens e congêneres."
	},
	"9609206": {
		"cnae_description": "Serviços de tatuagem e colocação de piercing",
		"service_code": "06.02",
		"service_description": "Esteticistas, tratamento de pele, depilação e congêneres."
	},
	"9609299": {
		"cnae_description": "Outras atividades de serviços pessoais não especificadas anteriormente",
		"service_code": "17.12",
		"service_description": "Administração em geral, inclusive de bens e negócios de terceiros."
	},
	"0162801": {
		"cnae_description": "Serviço de inseminação artificial em animais",
		"service_code": "05.04",
		"service_description": "Inseminação artificial, fertilização in vitro e congêneres."
	},
	"0162802": {
		"cnae_description": "SERVICO DE TOSQUIAMENTO DE OVINOS",
		"service_code": "05.08",
		"service_description": "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres."
	},
	"0162803": {
		"cnae_description": "SERVICO DE MANEJO DE ANIMAIS",
		"service_code": "05.08",
		"service_description": "Guarda, tratamento, amestramento, embelezamento, alojamento e congêneres."
	},
	"0162899": {
		"cnae_description": "ATIVIDADES DE APOIO A PECUARIA NAO ESPECIFICADAS ANTERIORMENTE",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"0161001": {
		"cnae_description": "Serviço de pulverização e controle de pragas agrícolas",
		"service_code": "07.13",
		"service_description": "Dedetização, desinfecção, desinsetização, imunização, higienização, desratização, pulverização e congêneres."
	},
	"0161003": {
		"cnae_description": "SERVICO DE PREPARACAO DE TERRENO, CULTIVO E COLHEITA",
		"service_code": "07.16",
		"service_description": "Florestamento, reflorestamento, semeadura, adubação e congêneres."
	},
	"0220906": {
		"cnae_description": "Conservação de florestas nativas",
		"service_code": "07.16",
		"service_description": "Florestamento, reflorestamento, semeadura, adubação e congêneres."
	},
	"0230600": {
		"cnae_description": "Atividades de apoio à produção florestal",
		"service_code": "07.16",
		"service_description": "Florestamento, reflorestamento, semeadura, adubação e congêneres."
	},
	"0910600": {
		"cnae_description": "Atividades de apoio à extração de petróleo e gás natural",
		"service_code": "07.21",
		"service_description": "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais."
	},
	"0990401": {
		"cnae_description": "ATIVIDADES DE APOIO A EXTRACAO DE MINERIO DE FERRO",
		"service_code": "07.21",
		"service_description": "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais."
	},
	"0990402": {
		"cnae_description": "ATIVIDADES DE APOIO A EXTRACAO DE MINERAIS METÁLICOS NÃO-FERROSOS",
		"service_code": "07.21",
		"service_description": "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais."
	},
	"0990403": {
		"cnae_description": "ATIVIDADES DE APOIO À EXTRAÇÃO DE MINERAIS NÃO-METÁLICOS",
		"service_code": "07.21",
		"service_description": "Pesquisa, perfuração, cimentação, mergulho, perfilagem, concretação, testemunhagem, pescaria, estimulação e outros serviços relacionados com a exploração e explotação de petróleo, gás natural e de outros recursos minerais."
	},
	"0311604": {
		"cnae_description": "ATIVIDADES DE APOIO A PESCA EM AGUA SALGADA",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"0312404": {
		"cnae_description": "ATIVIDADES DE APOIO A PESCA EM AGUA DOCE",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"0321305": {
		"cnae_description": "ATIVIDADES DE APOIO A AQUICULTURA EM AGUA SALGADA E SALOBRA",
		"service_code": "20.01",
		"service_description": "Serviços portuários, ferroportuários, utilização de porto, movimentação de passageiros, reboque de embarcações, rebocador escoteiro, atracação, desatracação, serviços de praticagem, capatazia, armazenagem de qualquer natureza, serviços acessórios, movimentação de mercadorias, serviços de apoio marítimo, de movimentação ao largo, serviços de armadores, estiva, conferência, logística e congêneres."
	},
	"0322107": {
		"cnae_description": "Atividades de apoio à aquicultura em água doce",
		"service_code": "17.01",
		"service_description": "Assessoria ou consultoria de qualquer natureza, não contida em outros itens desta lista; análise, exame, pesquisa, coleta, compilação e fornecimento de dados e informações de qualquer natureza, inclusive cadastro e similares."
	},
	"": {
		"cnae_description": "",
		"service_code": "",
		"service_description": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/views/Fiscal/NFSe/emit/utils/cnae_item.json
// module id = 620
// module chunks = 0